module.exports = __webpack_public_path__ + "img/Banner-SkyBuildings-dwnszd.5a81d942.jpg";